export enum ParticipantDocumentTypeEnum {
    ConfirmationStatement = 5,
    EOI = 8,
    DependentVerification = 9,
    ProofOfLifeEvent = 11,
    QMCSO = 12,
    Miscellaneous = 13,
    TaxForm = 14,
    TotalCompensation = 15,
}
